<template>
  <div class="e-asset-header forecast-modal-header" v-if="asset">
    <b-row>
      <div class="col-2 asset-info">
        <img class="logo" :src="asset.logoPath">
        <div class="info">
          <h2>{{ asset.name }}</h2>
          <small>({{ asset.symbol }})</small>
        </div>
      </div>
      <transition mode="out-in" name="fade">
        <b-col v-if="isHintVisible && hint" key="hint">
          <e-hint :title="hint.title || ''">{{ hint.text || '' }}</e-hint>
          <e-button color="gray" type="outlined" size="smaller" class="px-3 mt-2" @click="hideHint">{{ hint.buttonText }}</e-button>
        </b-col>
        <b-col v-else cols="10" key="asset-data">
          <div class="asset-meta">
            <div class="item" :class="coloredClass">
              <div class="value">{{ forecastData.asset.change24.toFixed(2) }}</div>
              <div class="title">Change in %</div>
            </div>
            <div class="item" :class="coloredClass">
              <div class="value">{{ evalPrice | formatPrice }}</div>
              <div class="title">
                Evaluated Price
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
                <path class="st0" d="M36.9,0H12.2c-0.8,0-1.6,0.3-2.2,0.9C9.5,1.5,9.2,2.2,9.2,3.1c0,0.8,0.3,1.6,0.9,2.2l8.5,8.5L0.5,31.8
                  C0.2,32.1,0,32.5,0,32.9c0,0.4,0.2,0.8,0.5,1.1L6,39.5C6.3,39.8,6.7,40,7.1,40c0.4,0,0.8-0.2,1.1-0.5l18.1-18.1l8.5,8.5
                  c0.6,0.6,1.3,0.9,2.2,0.9c0.8,0,1.6-0.3,2.2-0.9c0.6-0.6,0.9-1.3,0.9-2.2V3.1c0-0.8-0.3-1.6-0.9-2.2C38.5,0.3,37.8,0,36.9,0z"/>
                </svg>
            </div>
            </div>
            <div class="item">
              <div class="value">{{ forecastData.forecast.forecastDate | formatForecastDate }}</div>
              <div class="title">Forecast Date</div>
            </div>
            <div class="item">
              <div class="value">{{ forecastData.forecast.oracle }}</div>
              <div class="title">Type of Oracle</div>
            </div>
          </div>
        </b-col>
      </transition>
    </b-row>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex';

  import Services from '@services';
  import Cookies from 'cookies-js';
  import moment from 'moment';

  export default {
    name: "em-forecast-header",
    props: {
      hint: Object,
      type: String,
    },
    filters: {
      formatForecastDate(date) {
        return moment(date).format('DD MMM. YYYY');
      },
      formatPrice(price) {
        price = parseFloat(price);
        if(price <= 10) {
          return price.toFixed(6);
        } else if(price <= 50) {
          return price.toFixed(4);          
        }

        return price.toFixed(2)        
      }
    },
    data() {
		  return {
        isHintVisible: false,
      }
    },
    computed: {
		  ...mapGetters('forecast', {
        forecastData: 'forecastModalData'
      }),
      asset() {
        return this.forecastData !== null ? this.forecastData.asset : null;
      },
      evalPrice() {
        return this.forecastData.asset.change24 / 100 * this.asset.price.value + this.asset.price.value;
      },
      coloredClass() {
        return {
          'color-red': this.forecastData.asset.change24 < 0, 
          'color-green': this.forecastData.asset.change24 >= 0
        }
      }
    },
    methods: {
      hideHint() {
        this.isHintVisible = false;
        Cookies.set(`hintDisabled_${this.type}`, true);
      }
    },
    created() {
      let hintDisabled = Cookies.get(`hintDisabled_${this.type}`);
      this.isHintVisible = !hintDisabled;
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/forecast/header.vue